import { useTranslation } from "react-i18next";
import helpers from "../../../../Utils/helpers";
import { VossScheduledChangeStatusText, VossScheduledChangeStatus } from "../../../../Constants/VOSS/vossScheduledChangeStatus";
import {SkynetAnchor} from "../../../Fundamentals/Anchor/SkynetAnchor";


const ScheduledChangeRow = ({ change, onDelete }) => {
    const { t } = useTranslation();
    const allowDeletion = change.status === VossScheduledChangeStatus.Pending || change.status === VossScheduledChangeStatus.CompletedForUpcomingPeriod;

    return (
        <tr>
            <td className="bold">{t(VossScheduledChangeStatusText[change.status])}</td>
            <td>{change.tier?.name || '-'}</td>
            <td>{change.plan?.name || '-'}</td>
            <td>{helpers.formatDate(change.scheduledDate)}</td>
            <td width={200} className="text-center">
                <SkynetAnchor disabled={!allowDeletion} onClick={() => onDelete(change)}>{t('common.cancel')}</SkynetAnchor>
            </td>
        </tr>
    );
}

const ScheduledChangeTable = ({ scheduledChanges, onDelete, disabled, isLoading }) => {
    const { t } = useTranslation();

    return (
        <table className={`table table-stripe skynet-table-no-divider ${disabled ? 'disabled' : ''}`}>
            <thead>
                <tr>
                    <th>{t("scheduledChangeTable.status")}</th>
                    <th>{t("subscriptions.tier")}</th>
                    <th>{t("subscriptions.period")}</th>
                    <th>{t("scheduledChangeTable.date")}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
            {scheduledChanges?.length > 0 ? (
                scheduledChanges.map((change, index) => (
                    <ScheduledChangeRow key={`change-${index}`} change={change} onDelete={onDelete} />
                ))
            ) : (
                <tr><td colSpan={5}><em>{t("scheduledChangeTable.noScheduledChanges")}</em></td></tr>
            )}
            </tbody>
        </table>
    );
}

export default ScheduledChangeTable;